import type { FC } from "react";

import { ChangeValue } from "@similarweb/ui-components";

import { ComparisonMode } from "app/UtilitiesAndConstants/Constants/Moment";
import { translate } from "app/filters/i18nFilter";
import { DEFAULT_DECIMAL, FORMATTERS, PERCENTAGE } from "app/common/benchmark/formatters";

import { ChangeValueWrapper, GranularityIndicator } from "./styledComponents";

interface ChangeIndicatorProps {
    change: number;
    granularity?: ComparisonMode;
}
const ChangeIndicator: FC<ChangeIndicatorProps> = ({ change, granularity = ComparisonMode.YOY }) => {
    const rawPercentageChange = FORMATTERS.percent(change, DEFAULT_DECIMAL);
    const percentageWithSymbol = `${rawPercentageChange.toString()}${PERCENTAGE}`;

    return (
        <ChangeValueWrapper>
            <ChangeValue
                isDecrease={change < 0}
                unsigned={change === 0}
                value={percentageWithSymbol}
            />
            <GranularityIndicator
                isIncrease={change > 0}
                unsigned={change === 0}
            >
                {translate(`common.${granularity}`)}
            </GranularityIndicator>
        </ChangeValueWrapper>
    );
};

export default ChangeIndicator;
